import Vue from 'vue';
import axios from 'axios';
import qs from 'qs';

import misfitIds from '@/helpers/misfitIds.js';

// initial state
const state = {
  email: null,
  quizMisfitId: null,
  quizResult: null,
  // collectedMisfits: ['mer-bear-orange-pineapple', 'uni-shark-lychee-kiwi'],
  collectedMisfits: [],
}

// getters
const getters = {
  getQuizResult(state) {
    return state.quizResult;
  },
  getQuizMisfitId(state) {
    return state.quizMisfitId;
  },

  getTotalCorrectMisfits(state) {
    return state.collectedMisfits.length;
  },

  checkIfMisfitCollected: (state, getters) => (id) => {
    let collected = false;

    const misfits = getters['product/getMisfits'];

    for( let i=0; i<state.collectedMisfits.length; i++ ) {
      if( state.collectedMisfits[i] === id ) {
        return true;
      }
    }

    return false;
  },
}

// actions
const actions = {
  setEmail(value) {
    return new Promise((resolve, reject) => {
      commit('setEmail', {email:value});

      resolve();
    });
  },

  setQuizMisfitId({commit, state}, value) {
    console.log('setQuizMisfitId:', value);

    let found = false;

    for( let i in misfitIds ) {
      console.log(misfitIds[i]);
      if( misfitIds[i] === value ) {
        commit('setQuizMisfitId', {quizMisfitId: value});
        found = true;
        break;
      }
    }

    if( !found ) {
      console.log('INVALID MISFIT ID');
    }
  },

  setQuizResult({commit, state}, value) {
    commit('setQuizResult', {quizResult:value});
  },

  setTotalCorrectMisfits({commit, state}, value) {

  },

  submitUserInfo({commit, state}, data) {
    return new Promise((resolve, reject) => {
      let url = process.env.VUE_APP_API_URL;
      data.action = 'addEntry';

      axios({
        method: 'post',
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
        url: url,
        data: qs.stringify(data),
      })
        .then((response) => {
          console.log(response.data);

          if( response.data.code === 200 ) {
            commit('setCollectedMisfits', {collectedMisfits:response.data.entries});
            resolve();
          } else {
            commit('setCollectedMisfits', {collectedMisfits:[data.misfitId]});
          }

        })
        .catch((error) => {
          reject(error);
        })
    })
  },
}

// mutations
const mutations = {
  setEmail(state, payload) {
    state.email = payload.email;
  },

  setQuizMisfitId(state, payload) {
    state.quizMisfitId = payload.quizMisfitId;
  },

  setQuizResult(state, payload) {
    state.quizResult = payload.quizResult;
  },

  setCollectedMisfits(state, payload) {
    state.collectedMisfits = payload.collectedMisfits;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
